// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date-range{display:inline}.date-range.date-range--right{float:right}.date-range .cform__group{display:flex}.date-range__input{display:inline-block;margin-right:.5rem;width:10.36rem}", ""]);
// Exports
module.exports = exports;
